export const RDI_MAX_AGE = 60

const MONTHS_IN_A_YEAR = 12
const ANNUAL_PERCENTAGE_RATE_DEFAULT = 1.99 // in %

type RdiRatePerTerm = number | undefined
export type RdiCost = number | undefined

export type RdiCosts = {
  UNEMPLOYMENT_DEATH_INABILITY: RdiCost
  DEATH_INABILITY: RdiCost
  DEATH: RdiCost
}

interface RdiCostTableColumn {
  12: RdiRatePerTerm
  24: RdiRatePerTerm
  36: RdiRatePerTerm
  48: RdiRatePerTerm
  60: RdiRatePerTerm
  72: RdiRatePerTerm
  84: RdiRatePerTerm
  96: RdiRatePerTerm
  108: RdiRatePerTerm
  120: RdiRatePerTerm
}

interface RdiCostTable {
  1: RdiCostTableColumn
  2: RdiCostTableColumn
}

/**
RDI Cost Indication Table

Term	            DEATH SINGLE	              DEATH BOTH                  DEATH_INABILITY SINGLE	    DEATH_INABILITY BOTH	      UNEMPLOYMENT_DEATH_INABILITY SINGLE 	UNEMPLOYMENT_DEATH_INABILITY BOTH
                  Minimum Median 	Maximum	    Minimum	Median 	Maximum	    Minimum	Median 	Maximum	    Minimum Median 	Maximum	    Minimum	Median 	Maximum	              Minimum	Median 	Maximum
12 Monate	        0.23	  1.66	  2.65	      0.31	  1.12	1.48	        1.47	  2.64	  6.44	      1.49	  2.60	  4.64	      3.41	  4.26	  8.17	                3.47	  4.66	  8.71
24 Monate	        0.61	  2.42	  3.98	      0.96	  3.64	13.11	        1.89	  3.67	  5.55	      3.58	  5.62	  11.03	      3.90	  6.20	  11.52	                6.74	  7.94	  10.06
36 Monate	        0.93	  2.46	  6.39	      0.93	  2.49	9.82	        3.21	  4.27	  7.53	      4.65	  7.34	  10.40	      5.34	  8.67	  13.24	                7.71	  12.53	  14.85
48 Monate	        1.28	  3.71	  10.64	      0.95	  2.33	13.00	        3.44	  4.91	  9.31	      2.79	  5.56	  10.88	      6.84	  10.02	  16.05	                8.62	  14.05	  21.28
60 Monate	        1.62	  3.57	  9.48	      1.64	  4.49	13.57	        4.44	  6.02	  10.87	      4.92	  10.04	  17.27	      7.88	  11.27	  17.88	                6.90	  12.83	  17.98
72 Monate	        2.02	  5.26	  11.26	      3.56	  4.40	20.60	        5.52	  6.68	  12.03	      5.17	  11.60	  15.23	      3.23	  12.06	  19.62	                9.14	  16.13	  23.01
84 Monate	        1.91	  5.91	  10.92	      3.53	  6.35	20.12	        4.83	  7.60	  16.51	      3.98	  8.91	  16.08	      4.99	  13.75	  23.05	                5.38	  15.24	  23.46
96 Monate	        2.28	  6.09	  9.24	      5.44	  5.46	9.40	        6.75	  8.70	  17.79	      4.64	  10.48	  18.07	      7.37	  15.07	  26.57	                16.75	  20.84	  26.98
108 Monate 	      3.60	  8.31	  9.99	      7.02	  7.66  8.31	        5.14	  8.45	  10.64	      5.49	  11.23	  16.98	      6.48	  13.95	  18.46	                5.01	  13.95	  22.88
120 Monate	      4.26	  6.15	  10.34	      4.93	  7.97	13.43	        8.83	  9.65	  13.26	      10.65	  13.09	  19.40	      6.41	  15.46	  19.93	                6.94	  19.79	  21.58

in %
n/a = undefined

We do not need to calculate median and maximum values, so these columns are not considered.
*/

const RDI_COSTS_UNEMPLOYMENT_DEATH_INABILITY_DEBTOR_BOTH_MINIMUM: RdiCostTableColumn =
  {
    12: 3.47,
    24: 6.74,
    36: 7.71,
    48: 8.62,
    60: 6.9,
    72: 9.14,
    84: 5.38,
    96: 16.75,
    108: 5.01,
    120: 6.94
  }

const RDI_COSTS_UNEMPLOYMENT_DEATH_INABILITY_DEBTOR_SINGLE_MINIMUM: RdiCostTableColumn =
  {
    12: 3.41,
    24: 3.9,
    36: 5.34,
    48: 6.84,
    60: 7.88,
    72: 3.23,
    84: 4.99,
    96: 7.37,
    108: 6.48,
    120: 6.41
  }

const RDI_COSTS_DEATH_INABILITY_DEBTOR_BOTH_MINIMUM: RdiCostTableColumn = {
  12: 1.49,
  24: 3.58,
  36: 4.65,
  48: 2.79,
  60: 4.92,
  72: 5.17,
  84: 3.98,
  96: 4.64,
  108: 5.49,
  120: 10.65
}

const RDI_COSTS_DEATH_INABILITY_DEBTOR_SINGLE_MINIMUM: RdiCostTableColumn = {
  12: 1.47,
  24: 1.89,
  36: 3.21,
  48: 3.44,
  60: 4.44,
  72: 5.52,
  84: 4.83,
  96: 6.75,
  108: 5.14,
  120: 8.83
}

const RDI_COSTS_DEATH_DEBTOR_BOTH_MINIMUM: RdiCostTableColumn = {
  12: 0.31,
  24: 0.96,
  36: 0.93,
  48: 0.95,
  60: 1.64,
  72: 3.56,
  84: 3.53,
  96: 5.44,
  108: 7.02,
  120: 4.93
}

const RDI_COSTS_DEATH_DEBTOR_SINGLE_MINIMUM: RdiCostTableColumn = {
  12: 0.23,
  24: 0.61,
  36: 0.93,
  48: 1.28,
  60: 1.62,
  72: 2.02,
  84: 1.91,
  96: 2.28,
  108: 3.6,
  120: 4.26
}

const RDI_COSTS_TABLE_DEATH: RdiCostTable = {
  1: RDI_COSTS_DEATH_DEBTOR_SINGLE_MINIMUM,
  2: RDI_COSTS_DEATH_DEBTOR_BOTH_MINIMUM
}

const RDI_COSTS_TABLE_DEATH_INABILITY: RdiCostTable = {
  1: RDI_COSTS_DEATH_INABILITY_DEBTOR_SINGLE_MINIMUM,
  2: RDI_COSTS_DEATH_INABILITY_DEBTOR_BOTH_MINIMUM
}

const RDI_COSTS_TABLE_UNEMPLOYMENT_DEATH_INABILITY: RdiCostTable = {
  1: RDI_COSTS_UNEMPLOYMENT_DEATH_INABILITY_DEBTOR_SINGLE_MINIMUM,
  2: RDI_COSTS_UNEMPLOYMENT_DEATH_INABILITY_DEBTOR_BOTH_MINIMUM
}

const RDI_COSTS = {
  DEATH: RDI_COSTS_TABLE_DEATH,
  DEATH_INABILITY: RDI_COSTS_TABLE_DEATH_INABILITY,
  UNEMPLOYMENT_DEATH_INABILITY: RDI_COSTS_TABLE_UNEMPLOYMENT_DEATH_INABILITY
}

function getRdiRatePerTerm(
  rdiType: string,
  debtorCount: number,
  term: number
): RdiRatePerTerm {
  // @ts-ignore - RDI_COSTS type needs refinement for dynamic access
  return RDI_COSTS[rdiType][`${debtorCount}`][`${term}`]
}

function calculateRdiCostsPerTerm(
  amount: number,
  rdiRateAnnually: RdiRatePerTerm
): RdiCost {
  return rdiRateAnnually ? amount * (rdiRateAnnually / 100) : undefined
}

function calculateRdiCostsMonthly(
  rdiCostsAnually: RdiCost,
  annualPercentageRate: number,
  term: number
): RdiCost {
  if (!rdiCostsAnually) {
    return undefined
  }

  const annualPercentageRateDecimal = annualPercentageRate / 100
  const interestMonthly =
    (1 + annualPercentageRateDecimal) ** (1 / MONTHS_IN_A_YEAR) - 1

  return (
    Math.round(
      (100 *
        rdiCostsAnually! *
        ((1 + interestMonthly) ** term * interestMonthly)) /
        ((1 + interestMonthly) ** term - 1)
    ) / 100
  )
}

export function getRdiCostMonthly(
  amount: number,
  term: number,
  rdiType: string,
  debtorCount: number
): RdiCost {
  const rdiRateAnnually = getRdiRatePerTerm(rdiType, debtorCount, term)
  const rdiCostsAnnually = calculateRdiCostsPerTerm(amount, rdiRateAnnually)

  return calculateRdiCostsMonthly(
    rdiCostsAnnually,
    ANNUAL_PERCENTAGE_RATE_DEFAULT,
    term
  )
}
